export default __webpack_public_path__ + "static/media/Sumedh.39273aa5.jpeg";